import React from 'react';
import { useParams } from 'react-router-dom';

import ImportDetail from '../../components/Admin/ImportDetail';

function ImportDetailView() {
  const { importId } = useParams<{ importId: string }>();
  
  return (
    <ImportDetail key={importId} />
  );
}

export default ImportDetailView;

